export default __webpack_public_path__ + "static/media/lantern.477a46d0.png";